import {
  Heading,
  Section,
  SubHeading,
  UnorderedList
} from '~/components/Prefabs';

export default function AboutUsEnglish() {
  return (
    <>
      <Heading>About The Sole Supplier</Heading>
      <Section>
        <p>
          The Sole Supplier was founded in 2013, with the aim to provide
          accurate trainer news and release information for the UK and European
          market. Our community of partners (brands and enthusiasts) provide us
          with new and exclusive content daily alongside our dedicated in-house
          team of experts.
        </p>
        <p>
          Curation and selection are key processes for The Sole Supplier. Each
          item on site is handpicked with insight into legacy, fashion trends,
          audience and heritage considerations. Through working with over 50
          different retailers online, we provide up to date release information
          on the most coveted footwear from across the continent. The release
          dates section has become a pivotal destination for the sneaker and
          streetwear community, especially those looking to stay up to date with
          trends.
        </p>
        <p>
          The Sole Supplier’s news section is the landing place for all rumours
          and breaking information from the footwear community. Visitors will
          find this section littered with rumoured releases, leaked images and
          reviews from our team of trusted experts. Video content is also a
          heavy focus, to give a more dynamic, informative and visual insight
          into the latest trend from the footwear scene.
        </p>
        <p>
          The Sole Supplier iOS app relaunched in late 2018, with the purpose of
          providing an even smoother user experience for the sneaker community.
          Through our app, we also deliver all the latest releases, launch dates
          and confirmed stockists.
        </p>
      </Section>
      <Heading id="editorial-policy">Editorial Policy</Heading>
      <Section>
        <p>
          Born in 2013, The Sole Supplier aims to deliver the most up to date
          sneaker news and release information for the UK/European market. We
          are the fastest and most comprehensive sneaker information site,
          delivering daily content on exclusive sneaker releases.
        </p>
        <p>
          The Sole Supplier are committed to the highest editorial standards,
          ensuring our news and content is accurate and truthful. As sneaker
          experts, we are passionate about our content and giving our readers
          informed and up-to-date sneaker news. We live and breathe sneakers, so
          take great pride in our editorial principles and process.
        </p>
      </Section>
      <SubHeading>Editorial principles</SubHeading>
      <Section>
        <p>Our editorial principles are:</p>
        <p>
          <UnorderedList>
            <li>Accuracy</li>
            <li>Impartiality</li>
            <li>Transparency</li>
            <li>Accountability</li>
            <li>Originality</li>
          </UnorderedList>
        </p>
        <p>
          We work to ensure our content is accurate, impartial, transparent and
          that we are fully accountable to our readers. Our content and news is
          original, unique and serves an audience who are just as passionate
          about sneakers as we are.
        </p>
      </Section>
      <SubHeading>Editorial process</SubHeading>
      <Section>
        <p>
          To ensure we consistently meet our editorial principles, The Sole
          Supplier has a clear and rigorous editorial process:
        </p>
      </Section>
      <SubHeading>Planning</SubHeading>
      <Section>
        <p>
          We have a detailed content calendar which allows us to plan and
          structure our articles carefully over time, whilst also giving us the
          flexibility to respond to breaking news stories when they arise.
        </p>
      </Section>
      <SubHeading>Research</SubHeading>
      <Section>
        <p>
          Before writing our content commences, we undertake methodical research
          on each topic. All our content is carefully researched and fact
          checked to ensure accuracy at every level.
        </p>
      </Section>
      <SubHeading>Production</SubHeading>
      <Section>
        <p>
          Once a piece of content has been researched and planned, our dedicated
          team of sneaker specialists formally draft the article or news item.
        </p>
      </Section>
      <SubHeading>Visual assets</SubHeading>
      <Section>
        <p>
          During production we source relevant imagery or visual assets (and any
          associated permissions), or undertake our own imagery to give each
          article a unique visual edge.
        </p>
      </Section>
      <SubHeading>Editing and sign off</SubHeading>
      <Section>
        <p>
          Once drafted, each article is reviewed and edited by our senior team.
          Articles are checked for accuracy, tone, presentation and
          spelling/grammar. Once approved by an editor, the articles are either
          pushed live or scheduled for a particular date and time.
        </p>
      </Section>
      <SubHeading>Review and moderation</SubHeading>
      <Section>
        <p>
          Once an article is live, it is reviewed again for accuracy and
          presentation to ensure all correct spelling and styling has been
          implemented correctly. We also take feedback on all content from our
          audience on social media, and feed this back to the wider editorial
          team. This helps us to understand the kinds of content and formats
          which are resonating best with our audience, helping to inform our
          future content plans.
        </p>
      </Section>
      <Heading id="advertising-policy">Advertising Policy</Heading>
      <Section>
        <p>
          We write articles that will be of interest to you, with a focus on the
          latest news, trends, brands, product launches and offers.
        </p>
        <p>
          We write about products and services we think you may want to buy, and
          help you find where you can buy them. This means we will sometimes
          include links to those products. When we do, we usually use ‘affiliate
          links’. This means that if you click through those links to visit
          another company’s site or to buy a product, we might earn a commission
          from that company.
        </p>
        <p>
          We don’t receive commission on all sales, just ones where the other
          company has an affiliate scheme of which we are a member or where we
          have an agreement with them. Not all the links to other companies’
          websites are affiliate links, because we also link to various sites
          that we believe will be interesting to you.
        </p>
        <p>
          Our articles which do contain affiliate links will include the
          following disclosure notice at or near the top of the page, “We may
          earn a commission when you buy something from links on this page.
          Learn more”.
        </p>
        <p>
          In all cases, the products we feature are independently selected by
          our editors and we only recommend products we think you’ll love. We
          are very selective about who we work with, and we only collaborate
          with other companies to use affiliate links, create sponsored content
          and to allow advertising on our platforms when we think it’s something
          our readers and followers would be interested in, and it’s worthy of
          your time!
        </p>
      </Section>
    </>
  );
}
